module.exports = __webpack_public_path__ + "static/media/checkbox-checked.56b19e08.svg";